import React, { useCallback, useEffect, useState } from "react";
import { Drawer } from "antd";
import UserMonitors from "./user-monitors";

const DRAWER_WIDTH_KEY = "planOnline.userMonitor.drawer.width";
const MIN_WIDTH = 640;
const MAX_WIDTH = 1400;
const DEFAULT_WIDTH = 1100;
const SCREEN_MARGIN = 80;

const maxAllowedWidth = () => {
  if (typeof window === "undefined") return MAX_WIDTH;
  return Math.min(MAX_WIDTH, Math.max(MIN_WIDTH, window.innerWidth - SCREEN_MARGIN));
};

const clampWidth = (value) => {
  const max = maxAllowedWidth();
  const n = Number(value);
  if (!Number.isFinite(n)) return Math.min(DEFAULT_WIDTH, max);
  return Math.min(max, Math.max(MIN_WIDTH, Math.round(n)));
};

const loadWidth = () => {
  try {
    return clampWidth(localStorage.getItem(DRAWER_WIDTH_KEY) ?? DEFAULT_WIDTH);
  } catch {
    return DEFAULT_WIDTH;
  }
};

const saveWidth = (value) => {
  try {
    localStorage.setItem(DRAWER_WIDTH_KEY, String(clampWidth(value)));
  } catch {
    /* ignore */
  }
};

/**
 * Drawer с журналом действий пользователей по конкретному объекту.
 */
const UserMonitorDrawer = ({ open, onClose, title, fixedFilter, infoText }) => {
  const [size, setSize] = useState(loadWidth);

  useEffect(() => {
    if (!open) return undefined;
    const onWinResize = () => setSize((prev) => clampWidth(prev));
    onWinResize();
    window.addEventListener("resize", onWinResize);
    return () => window.removeEventListener("resize", onWinResize);
  }, [open]);

  const onResize = useCallback((next) => {
    setSize(clampWidth(next));
  }, []);

  const onResizeEnd = useCallback(
    (finalSize) => {
      const next = clampWidth(typeof finalSize === "number" ? finalSize : size);
      setSize(next);
      saveWidth(next);
    },
    [size]
  );

  return (
    <Drawer
      placement="right"
      title={title}
      open={open}
      onClose={onClose}
      destroyOnClose
      size={size}
      maxSize={maxAllowedWidth()}
      resizable={{
        onResize,
        onResizeEnd
      }}
      styles={{
        body: {
          display: "flex",
          flexDirection: "column",
          padding: "10px 12px",
          overflow: "hidden"
        }
      }}
    >
      {open ? (
        <UserMonitors
          fixedFilter={fixedFilter}
          periodDisabled
          persistFilters={false}
          infoText={infoText}
        />
      ) : null}
    </Drawer>
  );
};

export default UserMonitorDrawer;
